
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {Obi02Illustration as Obi02IllustrationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-02-illustration.js';
 
 
 

 
 export const Obi02Illustration = createComponent({
   react: React,
   tagName: 'obi-02-illustration',
   elementClass: Obi02IllustrationElement,
   events: {
     
   }
  });
 
 